import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import { User, UserVo } from "@supplier/entity";
import { confirmable } from "@/utils/decorator/confirmable";
import { UserListParam } from "@/entity/user";
export class UserService extends BaseService<User, UserVo, UserListParam, any> {
    public async get(id: number | string): Promise<any> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }

    @confirmable("是否删除")
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    /** 启用/禁用 */
    public async updateState(id: number, state: number) {
        const { data } = await this.service.put(`${this.path}/update/${id}/${state}`);
        return data;
    }

    /** 重置密码 */
    @confirmable("是否重置")
    public async resetPassword(id: number) {
        const { data } = await this.service.put(`${this.path}/reset-password/${id}`);
        return data;
    }

    /** 设置密码 */
    public async password(params: { newPassword: string; confirmPassword: string }) {
        const { data } = await this.service.put(`${this.path}/password`, params);
        return data;
    }

    /**
     * 账号管理下拉列表根据用户名和状态
     */
    public async selectorUser(params: { name?: string; state?: string; searchParam?: string }): Promise<User[]> {
        const { data } = await this.service.get(`${this.path}/selector-user`, { params });
        return data;
    }

    /**
     * 用于印章管理下拉列表根据用户名和状态
     */
    public async selectorUserOnSeal(params: { name?: string; state?: string; searchParam?: string }): Promise<User[]> {
        const { data } = await this.service.get(`${this.path}/selector-user-seal`, { params });
        return data;
    }
}

export const userService = new UserService("/user", request.service);
